export default "__VITE_ASSET__CohN$olE__"